import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Stack, InputAdornment } from "@mui/material";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TextField } from "@mui/material";
// import { FaFileExcel } from "react-icons/fa";
// import { FaFilePdf } from "react-icons/fa";
// import { FaRegCopy } from "react-icons/fa"; // outlined copy icon
import SearchIcon from "@mui/icons-material/Search"; // or any other icon
import { debounce } from "lodash";
import { useCallback } from "react";
import { useAppTheme } from "../../theme/useAppTheme";

const TableCompo = React.forwardRef(
  (
    {
      columns = [],
      data = [],
      title = "",
      loading = false,
      page = 0, // controlled from parent
      limit = 5, // controlled from parent
      totalCount = 0, // total items from backend
      onTableChange = () => {}, // callback to parent
      rowsPerPageOptions = [5, 10, 25, 50],
      pdfColumnWidths = {}, // ✅ New prop
    },
    ref
  ) => {
    // pagesize

    const [visibleColumns, setVisibleColumns] = useState(
      columns.filter((col) => !col.hide).map((col) => col.field)
    );

    const handleToggleColumn = (field) => {
      setVisibleColumns((prev) =>
        prev.includes(field)
          ? prev.filter((f) => f !== field)
          : [...prev, field]
      );
    };

    const filteredColumns = columns
      .filter((col) => visibleColumns.includes(col.field))
      .map((col) => ({
        ...col,
        flex: col.flex || 1,
        minWidth: col.minWidth || 150,
        sortable: col.sortable !== false,
        renderCell: col.render
          ? (params) => col.render(params.value, params.row)
          : undefined,
        headerClassName: "custom-header",
        cellClassName: "custom-cell",
      }));

    // // ✅ Excel Download
    // const handleDownloadExcel = () => {
    //   try {
    //     const exportableColumns = columns.filter((col) => !col.hideInExcel);
    //     const exportData = data.map((row) => {
    //       const formattedRow = {};
    //       exportableColumns.forEach((col) => {
    //         formattedRow[col.headerName || col.field] = row[col.field];
    //       });
    //       return formattedRow;
    //     });

    //     const worksheet = XLSX.utils.json_to_sheet(exportData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    //     const excelBuffer = XLSX.write(workbook, {
    //       bookType: "xlsx",
    //       type: "array",
    //     });

    //     const blob = new Blob([excelBuffer], {
    //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //     });

    //     saveAs(blob, `${title || "DataGrid"}_Export.xlsx`);

    //     toast.success("Excel file downloaded successfully!");
    //     // toast.warn("🔓 Please click 'Enable Editing' in Excel to modify the file.");
    //   } catch (error) {
    //     console.error("Excel download failed:", error);
    //     toast.error("Failed to download Excel.");
    //   }
    // };

    // // ✅ PDF Download with column width support
    // const handleDownloadPDF = () => {
    //   try {
    //     const doc = new jsPDF("l", "mm", "a4");

    //     const exportableColumns = columns.filter((col) => !col.hideInExcel);
    //     const tableColumnHeaders = exportableColumns.map(
    //       (col) => col.headerName || col.field
    //     );
    //     const tableRows = data.map((row) =>
    //       exportableColumns.map((col) => row[col.field] ?? "")
    //     );

    //     const columnStyles = {};
    //     exportableColumns.forEach((col, index) => {
    //       const width = pdfColumnWidths[col.field];
    //       if (width) {
    //         columnStyles[index] = { cellWidth: width };
    //       }
    //     });

    //     autoTable(doc, {
    //       head: [tableColumnHeaders],
    //       body: tableRows,
    //       startY: 20,
    //       margin: { left: 10, right: 10 },
    //       styles: {
    //         fontSize: 9,
    //         cellPadding: { top: 3, bottom: 3, left: 2, right: 2 },
    //         overflow: "linebreak",
    //       },
    //       headStyles: {
    //         fillColor: [63, 81, 181],
    //         textColor: "#ffffff",
    //         fontSize: 10,
    //         halign: "center",
    //       },
    //       columnStyles,
    //       didDrawPage: (data) => {
    //         doc.setFontSize(14);
    //         doc.text(title || "DataGrid Export", data.settings.margin.left, 10);
    //       },
    //     });

    //     doc.save(`${title || "DataGrid"}_Export.pdf`);
    //     toast.success("PDF file downloaded successfully!");
    //   } catch (error) {
    //     console.error("PDF download failed:", error);
    //     toast.error("Failed to download PDF.");
    //   }
    // };
    // // download csv
    // const handleDownloadCSV = () => {
    //   try {
    //     const exportableColumns = columns.filter((col) => !col.hideInExcel);
    //     const headers = exportableColumns.map(
    //       (col) => `"${col.headerName || col.field}"`
    //     );
    //     const rows = data.map((row) =>
    //       exportableColumns.map((col) => `"${row[col.field] ?? ""}"`)
    //     );
    //     const csvContent = [headers, ...rows]
    //       .map((r) => r.join(","))
    //       .join("\n");

    //     const blob = new Blob([csvContent], {
    //       type: "text/csv;charset=utf-8;",
    //     });
    //     saveAs(blob, `${title || "DataGrid"}_Export.csv`);

    //     toast.success("CSV file downloaded successfully!");
    //   } catch (error) {
    //     console.error("CSV download failed:", error);
    //     toast.error("Failed to download CSV.");
    //   }
    // };

    // // ✅ Copy to Clipboard
    // const handleCopyToClipboard = () => {
    //   const exportableColumns = columns.filter((col) => !col.hideInExcel);
    //   const headers = exportableColumns
    //     .map((col) => col.headerName || col.field)
    //     .join("\t"); // tab-separated

    //   const rows = data.map((row) =>
    //     exportableColumns.map((col) => row[col.field] ?? "").join("\t")
    //   );

    //   const clipboardText = [headers, ...rows].join("\n");

    //   navigator.clipboard
    //     .writeText(clipboardText)
    //     .then(() => {
    //       toast.success("Table data copied to clipboard!");
    //     })
    //     .catch((err) => {
    //       toast.error("Failed to copy table data.");
    //       console.error("Failed to copy: ", err);
    //     });
    // };

    const handleSearch = useCallback(
      debounce((value) => {
        onTableChange("search", { searchText: value });
      }, 2000),
      []
    );

    useEffect(() => {
      setVisibleColumns(
        columns.filter((col) => !col.hide).map((col) => col.field)
      );
    }, [columns]);

    const themeColors = useAppTheme();

    return (
      <Box sx={{ mt: 2, width: "100%" }}>
        {/* Right Side: Search */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <span style={{ color: "gray", fontSize: "14px" }}>Search :</span>
            <TextField
              size="small"
              placeholder="Search..."
              onChange={(e) => {
                handleSearch(e.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "#7028DA", ml: 1 }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "4px",
                  padding: "0px",
                  fontSize: "14px",
                  height: "38px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#7028DA",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#7028DA",
                },
                "& .MuiInputBase-input": {
                  padding: "3px 3px",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "14px",
                },
              }}
            />
          </Box> */}
        </Box>

        <Box
          sx={{
            width: "100%",
            minWidth: 0,
            background: themeColors.mediumContainer,
            color: themeColors.text,
            border: `1px solid ${themeColors.border}`,
            borderRadius: "18px",
            overflowX: "auto",

            "& .custom-header": {
              backgroundColor: `${themeColors.primary} !important`,
              color: themeColors.text,
              fontWeight: "bold",
              fontSize: "16px",
              textAlign: "center",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              padding: "12px 16px",
            },

            "& .custom-cell": {
              position: "relative", // required for pseudo-element
              fontSize: "14px",
              background: "transparent",
              color: themeColors.text,
             
              "& .MuiDataGrid-cell": {
                borderTop: "none !important",
              },
              "& .MuiDataGrid-row": {
                borderBottom: "none !important",
              },

              // vertical dividing line
              "&::after": {
                content: '""',
                position: "absolute",
                top: "8px", // vertical padding from top
                bottom: "8px", // vertical padding from bottom
                right: 0,
                width: "1px",
                backgroundColor: themeColors.border,
              },
            },

            // remove divider from last cell in each row
            "& .MuiDataGrid-row .MuiDataGrid-cell:last-child::after": {
              display: "none",
            },

            "& .MuiDataGrid-columnHeaders": {
              position: "sticky",
              top: 0,
              zIndex: 1,
              background: themeColors.primary,
              borderTopLeftRadius: "17px",
              borderTopRightRadius: "17px",
            },
            "& .MuiDataGrid-columnSeparator": { color: themeColors.border },
            "& .MuiDataGrid-scrollbarFiller, & .MuiDataGrid-filler, & .MuiDataGrid-scrollbarFiller--header, & .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeaders > div": {
              background: `${themeColors.primary} !important`,
              backgroundColor: `${themeColors.primary} !important`,
            },

            "& .MuiDataGrid-virtualScroller": {
              maxHeight: "400px",
              overflowY: "auto",
            },

            "& .MuiDataGrid-footerContainer": {
              borderTop: `1px solid ${themeColors.border}`,
              background: "transparent",
              color: themeColors.text,
            },
            "& .MuiTablePagination-root, & .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiSelect-select":
              { color: themeColors.text },
            "& .MuiSvgIcon-root": { color: themeColors.text },
          }}
        >
          <DataGrid
            rows={[...data]}
            columns={filteredColumns}
            // page={page}
            // rows={[...data].reverse()} // ✅ latest/updated rows first

            // pageSize={limit}
            rowCount={totalCount}
            paginationMode="server"
            paginationModel={{ page, pageSize: limit }}
            onPaginationModelChange={({ page, pageSize }) => {
              if (pageSize !== limit) {
                onTableChange("changeRowsPerPage", {
                  page: 0,
                  rowsPerPage: pageSize,
                });
              } else {
                onTableChange("changePage", {
                  page,
                  rowsPerPage: pageSize,
                });
              }
            }}
            pageSizeOptions={rowsPerPageOptions}
            loading={loading}
            getRowId={(row) => row._id || row.id}
            disableRowSelectionOnClick
            checkboxSelection={false}
            sx={{
              border: 0,
              minWidth: 720,
              background: "transparent",
              color: themeColors.text,
              "--DataGrid-containerBackground": themeColors.primary,
              "--DataGrid-t-header-background-base": themeColors.primary,
              "& .MuiDataGrid-row, & .MuiDataGrid-cell": { background: "transparent" },
              "& .MuiDataGrid-row:hover": { background: "rgba(128,128,128,0.10)" },
              "& .MuiDataGrid-row.Mui-selected, & .MuiDataGrid-row.Mui-selected:hover": {
                background: "rgba(128,128,128,0.15)",
              },
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-overlay": { background: "transparent" },
            }}
          />

          {/* <Box sx={{ mb: 1, px: 2 }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              mt={3}
            >
              <Stack direction="row" spacing={2}>
                <Button
                  variant="outlined"
                  startIcon={<FaFileExcel />}
                  sx={{
                    background:
                      "linear-gradient(to bottom, #fff 0%, #e9e9e9 100%)",
                    color: "#000",
                    border: "1px solid #999",
                  }}
                  onClick={handleDownloadCSV}
                >
                  CSV
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<FaFileExcel />}
                  sx={{
                    background:
                      "linear-gradient(to bottom, #fff 0%, #e9e9e9 100%)",
                    color: "#000",
                    border: "1px solid #999",
                  }}
                  onClick={handleDownloadExcel}
                >
                  Excel
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<FaFilePdf />}
                  sx={{
                    background:
                      "linear-gradient(to bottom, #fff 0%, #e9e9e9 100%)",
                    color: "#000",
                    border: "1px solid #999",
                  }}
                  onClick={handleDownloadPDF}
                >
                  PDF
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<FaRegCopy />}
                  sx={{
                    background:
                      "linear-gradient(to bottom, #fff 0%, #e9e9e9 100%)",
                    color: "#000",
                    border: "1px solid #999",
                  }}
                  onClick={handleCopyToClipboard}
                >
                  Copy
                </Button>
              </Stack>
            </Stack>
          </Box> */}
        </Box>
      </Box>
    );
  }
);

export default TableCompo;
